import { render, staticRenderFns } from "./RegistView.vue?vue&type=template&id=2e2092f8&scoped=true&"
import script from "./RegistView.vue?vue&type=script&lang=js&"
export * from "./RegistView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2092f8",
  null
  
)

export default component.exports